module.exports = __webpack_public_path__ + "static/media/llama.ad8db1ed.png";